<template><span aria-hidden="true"></span></template>

<script>
import {mapState} from 'vuex'

const PRODUCT_FIELDS = ['ItemId', 'Title', 'MinPrice', 'MainImage', 'MainPicList', 'DescPicList', 'SkuList', 'PropMap', 'VideoUrl', 'CatIds', 'CatNames', 'ShopId', 'ShopName']

export default {
  name: 'LinkImportTaskRunner',
  data() {
    return {
      running: false, halted: false,
      workerId: (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`,
      timer: null,
    }
  },
  computed: {
    ...mapState('login', ['token']),
  },
  watch: {
    token(value) {
      if (value) this.schedule(0)
      else { clearTimeout(this.timer); this.$store.commit('linkImport/SET_TASKS', []) }
    },
  },
  mounted() { if (this.token) this.schedule(0) },
  beforeDestroy() { clearTimeout(this.timer) },
  methods: {
    schedule(delay) {
      clearTimeout(this.timer)
      if (this.token && !this.halted) this.timer = setTimeout(() => this.pump(), delay)
    },
    async refresh() {
      try {
        const res = await this.$store.dispatch('linkImport/getTasks')
        if (res.code === 200) this.$store.commit('linkImport/SET_TASKS', res.data)
      } catch (error) { /* the next poll will retry */ }
    },
    async pump() {
      if (this.running || this.halted || !this.token) return
      this.running = true
      const activeToken = this.token
      let delay = 8000
      try {
        await this.refresh()
        if (!this.token || this.token !== activeToken) return
        let task = (this.$store.state.linkImport.tasks || []).find(item => ['waiting_plugin', 'fetching'].includes(item.status))
        let claimed = null
        // The task list is only a display API. Claiming is the durable source of
        // work, so a temporary list failure must not leave a saved task stuck.
        if (!task) {
          if (window.__isGxsExtensionInstalled__ === false) return
          claimed = await this.$store.dispatch('linkImport/claimItem', {worker_id: this.workerId})
          if (claimed.code !== 200) throw new Error(claimed.message || '领取任务失败')
          const item = claimed.data || {}
          if (item.state === 'complete') {
            await this.$store.dispatch('linkImport/finishTask', {task_id: item.task_id})
            return
          }
          if (item.state !== 'item') return
          task = {id: item.task_id, status: 'fetching'}
          this.$store.commit('linkImport/UPSERT_TASK', task)
        }
        if (window.__isGxsExtensionInstalled__ === false) {
          await this.$store.dispatch('linkImport/waitForPlugin', {task_id: task.id, worker_id: this.workerId, message: '未检测到观星树运营插件，请安装插件后继续'})
          return
        }
        let online
        try {
          online = await this.callExtension('xingjieliu_check_online', null, ['xingjieliu_content', 'xingjieliu_check_online_result'], 'ONLINE_RESULT', 8000)
        } catch (error) {
          if (error.message !== 'timeout') throw error
          await this.$store.dispatch('linkImport/waitForPlugin', {task_id: task.id, worker_id: this.workerId, message: '未检测到插件响应，请确认插件允许访问本站'})
          return
        }
        const onlineData = online && (online.data || online)
        if (!online || online.success === false || !onlineData || onlineData.online !== true) {
          await this.$store.dispatch('linkImport/waitForPlugin', {task_id: task.id, worker_id: this.workerId, message: '观星树运营插件不在线，请开启插件后继续'})
          return
        }
        if (onlineData.loggedIn !== true) {
          await this.$store.dispatch('linkImport/waitForPlugin', {task_id: task.id, worker_id: this.workerId, message: '请先在浏览器中登录抖音后再使用DY链接任务'})
          return
        }
        if (!this.token || this.token !== activeToken) return
        if (!claimed) claimed = await this.$store.dispatch('linkImport/claimItem', {worker_id: this.workerId})
        if (claimed.code !== 200) throw new Error(claimed.message || '领取任务失败')
        const item = claimed.data || {}
        if (item.state === 'complete') {
          await this.$store.dispatch('linkImport/finishTask', {task_id: item.task_id})
          return
        }
        if (item.state !== 'item') return
        let product = null
        let error = null
        try {
          const result = await this.callExtension('TRY_GET', item.url, 'xingjieliu_content', 'GET_RESULT', 45000)
          if (result && result.success && result.data && typeof result.data === 'object') {
            product = {}
            PRODUCT_FIELDS.forEach(key => { if (Object.prototype.hasOwnProperty.call(result.data, key)) product[key] = result.data[key] })
          } else error = String((result && result.error) || '插件未获取到商品详情')
        } catch (fetchError) {
          if (fetchError.message === 'timeout') {
            this.halted = true
            await this.$store.dispatch('linkImport/waitForPlugin', {task_id: item.task_id, worker_id: this.workerId, message: '插件请求超时，请刷新本站标签页后续跑'})
            return
          }
          error = fetchError.message || '插件抓取失败'
        }
        if (!this.token || this.token !== activeToken) return
        const reported = await this.$store.dispatch('linkImport/reportItem', {
          task_id: item.task_id, item_id: item.item_id, worker_id: this.workerId, product, error
        })
        if (reported.code !== 200 && product) {
          await this.$store.dispatch('linkImport/reportItem', {
            task_id: item.task_id, item_id: item.item_id, worker_id: this.workerId,
            product: null, error: reported.message || '商品数据校验失败'
          })
        }
        delay = 3000
      } catch (error) {
        delay = 10000
      } finally {
        this.running = false
        this.schedule(delay)
      }
    },
    callExtension(type, url, source, responseType, timeout) {
      return new Promise((resolve, reject) => {
        const listener = event => {
          if (event.source !== window || !event.data || !(Array.isArray(source) ? source : [source]).includes(event.data.source) || event.data.type !== responseType) return
          clearTimeout(timer)
          window.removeEventListener('message', listener)
          resolve(event.data.data)
        }
        const timer = setTimeout(() => { window.removeEventListener('message', listener); reject(new Error('timeout')) }, timeout)
        window.addEventListener('message', listener)
        const message = {source: 'demo_page', type}
        if (url) message.url = url
        window.postMessage(message, '*')
      })
    },
  },
}
</script>
